import React, { useContext } from "react";
import { PatientContext } from "../lib/main-context";
import { useTranslation } from "../i18n/TranslationProvider";

import Row from "react-bootstrap/Row";
import Col from "react-bootstrap/Col";
import SadSallie from "../images/Sallie-Oops.png";
import Sallie_tail from "../images/Sallie_tail2.gif";

// Sallie takes up one row of whatever container she is in. 2 cols are for the img, and 10 are for the text. Text box shrinks to fit smaller messaged
const Sallie = ({ user, text, sad, isCG, isProvider }) => {
  const { t } = useTranslation();
  const { patient } = useContext(PatientContext);

  let gif = Sallie_tail;
  let img = gif;

  if (sad) {
    img = SadSallie;
  }

  //console.log(patient);

  return (
    <Row>
      <Col
        md={2}
        style={{ minWidth: "125px" }}
        className="d-flex align-items-center justify-content-center"
      >
        <img
          style={{ maxWidth: "100%", maxHeight: "100%" }}
          src={img}
          alt={t("common.sallieAlt")}
        />
      </Col>
      <Col className="p-0" style={{ maxWidth: "fit-content" }}>
        <div className="sallie">
          <h6>{text}</h6>
        </div>
      </Col>

      {(isProvider || isCG) && (
        <Col
          className="p-0 d-flex justify-content-center align-items-center"
          style={{ maxWidth: "fit-content" }}
        >
          <div
            style={{
              paddingBottom: "0.5rem",
              margin: "0.5rem",
              whiteSpace: "nowrap",
            }}
          >
            <h6>
              {isProvider && patient?.caregiverId ? (
                <>
                  {t("dashboard.sallieDashboard.patientInfo.viewingCaregiver")}
                  <span style={{ fontWeight: "bold" }}>
                    {patient.caregiverName?.toUpperCase()}
                  </span>
                  {t("dashboard.sallieDashboard.patientInfo.trackingForPatient")}
                  <br></br>
                  <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                    {patient.firstName} {patient.lastName}
                  </span>
                  {patient.externalId && `, ID: ${patient.externalId}`}
                </>
              ) : isProvider ? (
                <>
                  {t("dashboard.sallieDashboard.patientInfo.provider")}
                  <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                    {patient?.firstName} {patient?.lastName}
                  </span>
                  {patient?.externalId && `, ID: ${patient.externalId}`}
                </>
              ) : (
                <>
                  {t("dashboard.sallieDashboard.patientInfo.nonProvider")}
                  <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                    {patient?.firstName} {patient?.lastName}
                  </span>
                  {patient?.externalId && `, ID: ${patient.externalId}`}
                  {patient?.firstName && patient?.lastName && patient?.patientId && (
                    <>
                      <br />
                      <div style={{ marginTop: "1rem" }}>
                        {t("dashboard.sallieDashboard.patientInfo.yourProvider")}
                        {patient?.assignedProvider?.firstName && patient?.assignedProvider?.lastName ? (
                          <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                            {patient?.assignedProvider?.firstName} {patient?.assignedProvider?.lastName}
                          </span>
                        ) : (
                          <span style={{ color: "#FDB913", fontWeight: "500", fontSize: "1.8rem" }}>
                            {t("messages.ui.notAssigned")}
                          </span>
                        )}
                      </div>
                      {patient?.clinic_location === "Virtual" && (
                        <div style={{ marginTop: "0.5rem" }}>
                          {t("dashboard.sallieDashboard.patientInfo.yourVirtualTherapist")}
                          {patient?.assignedVirtualTherapist?.firstName && patient?.assignedVirtualTherapist?.lastName ? (
                            <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                              {patient?.assignedVirtualTherapist?.firstName} {patient?.assignedVirtualTherapist?.lastName}
                            </span>
                          ) : (
                            <span style={{ color: "#FDB913", fontWeight: "500", fontSize: "1.8rem" }}>
                              {t("messages.ui.notAssigned")}
                            </span>
                          )}
                        </div>
                      )}
                    </>
                  )}
                </>
              )}
            </h6>
          </div>
        </Col>
      )}

      {/* Patient view - show provider info - only on Dashboard */}
      {user && !isProvider && !isCG && patient?.firstName && patient?.lastName && patient?.patientId && (
        <Col
          className="p-0 d-flex justify-content-center align-items-center"
          style={{ maxWidth: "fit-content" }}
        >
          <div
            style={{
              paddingBottom: "0.5rem",
              margin: "0.5rem",
              whiteSpace: "nowrap",
            }}
          >
            <h6>
              {t("dashboard.sallieDashboard.patientInfo.yourProvider")}
              {patient?.assignedProvider?.firstName && patient?.assignedProvider?.lastName ? (
                <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                  {patient?.assignedProvider?.firstName} {patient?.assignedProvider?.lastName}
                </span>
              ) : (
                <span style={{ color: "#FDB913", fontWeight: "500", fontSize: "1.8rem" }}>
                  {t("messages.ui.notAssigned")}
                </span>
              )}
              {patient?.clinic_location === "Virtual" && (
                <div style={{ marginTop: "0.5rem" }}>
                  {t("dashboard.sallieDashboard.patientInfo.yourVirtualTherapist")}
                  {patient?.assignedVirtualTherapist?.firstName && patient?.assignedVirtualTherapist?.lastName ? (
                    <span style={{ fontWeight: "bold", fontSize: "1.8rem" }}>
                      {patient?.assignedVirtualTherapist?.firstName} {patient?.assignedVirtualTherapist?.lastName}
                    </span>
                  ) : (
                    <span style={{ color: "#FDB913", fontWeight: "500", fontSize: "1.8rem" }}>
                      {t("messages.ui.notAssigned")}
                    </span>
                  )}
                </div>
              )}
            </h6>
          </div>
        </Col>
      )}
    </Row>
  );
};

export default Sallie;